import { render, staticRenderFns } from "./FeesForStopPage.vue?vue&type=template&id=2d2c908b&scoped=true&"
import script from "./FeesForStopPage.vue?vue&type=script&lang=js&"
export * from "./FeesForStopPage.vue?vue&type=script&lang=js&"
import style0 from "./FeesForStopPage.vue?vue&type=style&index=0&id=2d2c908b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c908b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2c908b')) {
      api.createRecord('2d2c908b', component.options)
    } else {
      api.reload('2d2c908b', component.options)
    }
    module.hot.accept("./FeesForStopPage.vue?vue&type=template&id=2d2c908b&scoped=true&", function () {
      api.rerender('2d2c908b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/calculation/feesForStop/FeesForStopPage.vue"
export default component.exports